// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Permanent+Marker&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor {

  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 5px;
  margin-right: 5px;

}

h1 {

  font-family: 'Permanent Marker', cursive;
  color: orange;
}

.sistema {

  height: 55px;
  display: inline-flex;


}

.logo {


  width: 55px;
  height: 55px;

}

.informacion {

  margin-right: 20px;

}

ngb-alert {

  background-color: rgba(226, 214, 37, 0.8);
  height: 30px;
  border-radius: 10px;
  color: firebrick;
 
}

/*@GOOGLE*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}

.btn-google {

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.md-24 {

  font-size: 24px;

}

.md-25 {

  font-size: 24px;

}

.md-36 {

  font-size: 36px;

}

.md-48 {

  font-size: 48px;

}

/*@GOOGLE*/`, "",{"version":3,"sources":["webpack://./src/app/slider/menu/menu.component.css"],"names":[],"mappings":"AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;;EAEE,wCAAwC;EACxC,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;;;AAGtB;;AAEA;;;EAGE,WAAW;EACX,YAAY;;AAEd;;AAEA;;EAEE,kBAAkB;;AAEpB;;AAEA;;EAEE,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA,UAAU;AACV;EACE,eAAe;EACf;;;;;AAKF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA,UAAU","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Permanent+Marker&display=swap');\r\n\r\n.contenedor {\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-left: 5px;\r\n  margin-right: 5px;\r\n\r\n}\r\n\r\nh1 {\r\n\r\n  font-family: 'Permanent Marker', cursive;\r\n  color: orange;\r\n}\r\n\r\n.sistema {\r\n\r\n  height: 55px;\r\n  display: inline-flex;\r\n\r\n\r\n}\r\n\r\n.logo {\r\n\r\n\r\n  width: 55px;\r\n  height: 55px;\r\n\r\n}\r\n\r\n.informacion {\r\n\r\n  margin-right: 20px;\r\n\r\n}\r\n\r\nngb-alert {\r\n\r\n  background-color: rgba(226, 214, 37, 0.8);\r\n  height: 30px;\r\n  border-radius: 10px;\r\n  color: firebrick;\r\n \r\n}\r\n\r\n/*@GOOGLE*/\r\n.material-symbols-outlined {\r\n  cursor: pointer;\r\n  font-variation-settings:\r\n  'FILL' 0,\r\n  'wght' 400,\r\n  'GRAD' 0,\r\n  'opsz' 24\r\n}\r\n\r\n.btn-google {\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.md-24 {\r\n\r\n  font-size: 24px;\r\n\r\n}\r\n\r\n.md-25 {\r\n\r\n  font-size: 24px;\r\n\r\n}\r\n\r\n.md-36 {\r\n\r\n  font-size: 36px;\r\n\r\n}\r\n\r\n.md-48 {\r\n\r\n  font-size: 48px;\r\n\r\n}\r\n\r\n/*@GOOGLE*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
